/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Macros_ExcelInputs */

const en_gc_resources_compare_macros_excel = /** @type {(inputs: Gc_Resources_Compare_Macros_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported in desktop Excel`)
};

const zh_gc_resources_compare_macros_excel = /** @type {(inputs: Gc_Resources_Compare_Macros_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面版 Excel 支持`)
};

/**
* | output |
* | --- |
* | "Supported in desktop Excel" |
*
* @param {Gc_Resources_Compare_Macros_ExcelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_macros_excel = /** @type {((inputs?: Gc_Resources_Compare_Macros_ExcelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Macros_ExcelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_macros_excel(inputs)
	return zh_gc_resources_compare_macros_excel(inputs)
});
export { gc_resources_compare_macros_excel as "gc.resources.compare.macros.excel" }